import { useEffect, useState } from "react";
import { api } from "../API";

export const getPropertiesPage = async (pageParam = 1, options = {}) => {
	const response = await api.get(`/api/v1/tenants/houses`, options);
	
	// Transform API response to match PropertyCard expected format
	if (response.data && response.data.status === 200 && response.data.data) {
		const transformedData = response.data.data.map((house) => {
			const hasImages = house.images && house.images.length > 0;
			return {
				id: house.id,
				rent: parseFloat(house.metadata?.unit_rent || 0),
				location: house.related_rental?.location || "Location not specified",
				image: hasImages 
					? house.images[0].image 
					: "/images/rent-beta.png",
				posted: "Available", // Default value, can be customized
				kitchen: house.has_inside_kitchen ? "Inside" : "Outside",
				bath: house.number_of_bathrooms || 0,
				terms: house.metadata?.unit_rent_cycle || "MONTHLY",
				// Additional data for future use
				bedrooms: house.number_of_bedrooms || 0,
				unitName: house.unit_name,
				rentalName: house.related_rental?.rental_name,
				_hasImages: hasImages, // Internal flag for sorting (removed from final output)
			};
		});

		// Sort: properties with images first, then those without
		const sorted = transformedData.sort((a, b) => {
			if (a._hasImages && !b._hasImages) return -1;
			if (!a._hasImages && b._hasImages) return 1;
			return 0;
		});

		// Remove the temporary sorting flag
		return sorted.map(({ _hasImages, ...rest }) => rest);
	}
	
	return [];
};

const useProperties = (pageNum = 1) => {
	const [results, setResults] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);
	const [error, setError] = useState({});
	const [hasNextPage, setHasNextPage] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		setIsError(false);
		setError({});

		const controller = new AbortController();
		const { signal } = controller;

		getPropertiesPage(pageNum, { signal: signal })
			.then((data) => {
				if (pageNum === 1) {
					// First page: replace results
					setResults(data);
					// Disable pagination since API returns all results at once
					setHasNextPage(false);
				} else {
					// Subsequent pages: append results (if API supports pagination in future)
					setResults((prev) => [...prev, ...data]);
					setHasNextPage(Boolean(data.length));
				}
				setIsLoading(false);
			})
			.catch((e) => {
				setIsLoading(false);
				if (signal.aborted) return;
				setIsError(true);
				setError({ message: e.message });
			});

		return () => controller.abort();
	}, [pageNum]);

	return { isLoading, isError, error, results, hasNextPage };
};

export default useProperties;
